import { useQuery } from '@tanstack/react-query';
import { GetRoleResponseSchema, type GetRoleResponse, type RoleEntity } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useRole(id: string) {
  const client = useApiClient();
  return useQuery<RoleEntity>({
    queryKey: ['role', id],
    queryFn: async ({ signal }) => {
      const res = await client.get<GetRoleResponse>(
        `/roles/${id}`,
        { signal },
        GetRoleResponseSchema,
      );
      return res.role;
    },
    enabled: !!id,
  });
}
